import * as MutationsType from "./mutationsType";
import requestAxios from "@/helpers/request_axios";

export default {
  async getLoyaltyConfig({ commit }) {
    const response = await requestAxios({
      url: "/awy/api/v1/loyalty",
      method: "GET",
    });

    const data = response.data.data;
    commit(MutationsType.SET_LOYALTY, data);
    return data;
  },
  async saveLoyaltyConfig({ commit }) {
    const response = await requestAxios({
      url: "/awy/api/v1/loyalty",
      method: "POST",
    });

    const data = response.data.data;
    commit(MutationsType.SET_LOYALTY, data);
    return data;
  },
  async updateLoyaltyConfig({ commit }, { collectPorcent, redeemPoints }) {
    const response = await requestAxios({
      url: "/awy/api/v1/loyalty",
      method: "PATCH",
      data: {
        collect_porcent: collectPorcent,
        redeem_points: redeemPoints,
      },
    });

    const data = response.data.data;
    commit(MutationsType.SET_LOYALTY, data);
    return data;
  },
  resetModuleLoyalty({ commit }) {
    commit(MutationsType.SET_LOYALTY, null);
  },
  async getLoyaltyClientResume({ commit }, { documentNumber }) {
    try {
      const response = await requestAxios({
        url: "/awy/api/v1/loyalty/points",
        method: "GET",
        params: {
          document_number: documentNumber,
        },
      });

      const data = response.data.data;
      commit(MutationsType.SET_LOYALTY_CLIENT, data);
      return data;
    } catch (error) {
      throw error.response.data;
    }
  },
  resetModuleLoyaltyClient({ commit }) {
    commit(MutationsType.SET_LOYALTY_CLIENT, null);
  },
  async getLoyaltyTransactionsByDocumentNumber({ commit }, { documentNumber }) {
    const response = await requestAxios({
      url: "/awy/api/v1/loyalty/transactions",
      method: "GET",
      params: {
        document_number: documentNumber,
      },
    });

    const data = response.data.data;
    commit(MutationsType.SET_LOYALTY_CLIENT_TRANSACTIONS, data);
    return data;
  },
  resetModuleLoyaltyClientTransactions({ commit }) {
    commit(MutationsType.SET_LOYALTY_CLIENT_TRANSACTIONS, null);
  },
  async collectLoyaltyPoints({ commit, state }, { documentNumber, amount }) {
    try {
      const response = await requestAxios({
        url: "/awy/api/v1/loyalty/collect",
        method: "POST",
        data: {
          document_number: documentNumber,
          amount: amount,
        },
      });

      const data = response.data;
      commit(MutationsType.SET_LOYALTY_CLIENT, {
        ...state.loyaltyClient,
        collect_points: state.loyaltyClient.collect_points + data.data.points,
      });
      return data;
    } catch (error) {
      throw error.response.data;
    }
  },
  async redeemLoyaltyPoints({ commit, state }, { documentNumber, points }) {
    try {
      const response = await requestAxios({
        url: "/awy/api/v1/loyalty/redeem",
        method: "POST",
        data: {
          document_number: documentNumber,
          points: points,
        },
      });

      const data = response.data;
      commit(MutationsType.SET_LOYALTY_CLIENT, {
        ...state.loyaltyClient,
        collect_points: state.loyaltyClient.collect_points - data.data.points,
      });
      return data;
    } catch (error) {
      throw error.response.data;
    }
  },
  async handleSegmentationMatrixConfig({ commit, state }, { pointX, pointY1, pointY2 }) {
    try {
      const response = await requestAxios({
        url: "/awy/api/v1/loyalty/segmentation/config",
        method: "POST",
        data: {
          point_x: pointX,
          point_y1: pointY1,
          point_y2: pointY2,
        },
      });

      const data = response.data;
      commit(MutationsType.SET_LOYALTY_SEGMENTATION_CONFIG, {
        ...state.loyaltySegmentationConfig,
        ...data,
      });
      return data;
    } catch (error) {
      throw error.response.data;
    }
  },
  async generateSegmentationMatrix({ commit, state }, { store, dateStart, dateEnd }) {
    try {
      const response = await requestAxios({
        url: "/awy/api/v1/loyalty/segmentation",
        method: "POST",
        data: {
          store: store,
          date_start: dateStart,
          date_end: dateEnd,
        },
      });

      const data = response.data;
      commit(MutationsType.SET_LOYALTY_SEGMENTATION_CONFIG, {
        ...state.loyaltySegmentationConfig,
        ...data.data.config,
      });
      commit(MutationsType.SET_LOYALTY_SEGMENTATION, {
        ...state.loyaltySegmentation,
        ...data.data.data,
      });
      return data;
    } catch (error) {
      throw error.response.data;
    }
  },
  // eslint-disable-next-line
  async generateSegmentationSegment({}, { slot, store, dateStart, dateEnd }) {
    try {
      const response = await requestAxios({
        url: "/awy/api/v1/loyalty/segmentation/segment",
        method: "POST",
        data: {
          slot: slot,
          store: store,
          date_start: dateStart,
          date_end: dateEnd,
        },
      });

      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
};
